/* ---------------------------------------------------------------------------
   Concierge behaviour. Lifted out of sections/concierge.liquid so the section
   is small enough to edit through the Admin API, and so this parses once and
   caches instead of shipping inside every page's HTML.

   THE SAVING LINE. This used to say "a second piece takes 5 percent off the
   whole basket", which was the old quantity ladder. The discounts key off
   order VALUE and have done for some time, so the widget was promising a
   saving the checkout would not give. It now reads the live thresholds from
   window.HY_TIERS, which layout/theme.liquid emits from theme settings, so
   there is still exactly one place to change them. Since 24 September it
   leads with the multi buy saving, 5 percent at two pieces and 10 at three.

   THE LAUNCHER CAN BE PUT AWAY. A small x on its corner, or a swipe right or
   down on a phone, hides it for seven days. On a phone it sat on the same
   strip as the sticky buy bar, and a help button a visitor cannot get rid of
   is the kind of thing that reads as nagging.
--------------------------------------------------------------------------- */
(function(){
  var root = document.querySelector('[data-concierge]');
  if(!root) return;
  var dataEl = document.querySelector('[data-con-knowledge]');
  if(!dataEl) return;

  var KB;
  try { KB = JSON.parse(dataEl.textContent); } catch(e){ return; }

  var panel = root.querySelector('[data-con-panel]');
  var body  = root.querySelector('[data-con-body]');
  var chips = root.querySelector('[data-con-chips]');
  var form  = root.querySelector('[data-con-form]');
  var input = root.querySelector('[data-con-input]');
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* The first threshold, in pounds, straight from theme settings. */
  function tierLine(){
    var line = 'Anything from the collection can be mixed: any two pieces take 5 percent off, ' +
               'three or more take 10 percent off.';
    var t = window.HY_TIERS && window.HY_TIERS[0];
    if(!t) return line;
    var pounds = Math.round(t[0] / 100).toLocaleString('en-GB');
    return line + ' Orders over £' + pounds + ' take ' + t[1] +
           ' percent off the whole order instead, whichever is worth more.';
  }

  /* ---- Put it away: an x on the corner, or a swipe on a phone ---- */
  var HIDE = 'haloyard:concierge-hidden';
  var WEEK = 7 * 24 * 60 * 60 * 1000;
  function hiddenRecently(){
    try { var t = Number(localStorage.getItem(HIDE)); return !!t && (Date.now() - t < WEEK); }
    catch(e){ return false; }
  }
  if(hiddenRecently()){ root.hidden = true; return; }

  var launch = root.querySelector('[data-con-open]');
  var swallow = false;

  function putAway(){
    try { localStorage.setItem(HIDE, String(Date.now())); } catch(e){}
    root.classList.add('is-gone');
    setTimeout(function(){ root.hidden = true; }, reduce ? 0 : 280);
  }

  var xBtn = document.createElement('button');
  xBtn.type = 'button';
  xBtn.className = 'hy-con__dismiss';
  xBtn.setAttribute('aria-label', 'Hide the help button');
  xBtn.innerHTML = '<svg viewBox="0 0 24 24" width="11" height="11" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
  xBtn.addEventListener('click', function(e){ e.stopPropagation(); putAway(); });
  root.appendChild(xBtn);

  /* A swipe right or down on the launcher puts it away. A short drag springs
     back, and the tap that ends a swipe never opens the panel. */
  var sx = 0, sy = 0, dx = 0, dy = 0, dragging = false;
  launch.addEventListener('touchstart', function(e){
    var t = e.touches[0]; sx = t.clientX; sy = t.clientY; dx = 0; dy = 0; dragging = true;
    launch.style.transition = 'none';
  }, { passive: true });
  launch.addEventListener('touchmove', function(e){
    if(!dragging) return;
    var t = e.touches[0];
    dx = Math.max(0, t.clientX - sx); dy = Math.max(0, t.clientY - sy);
    var d = Math.max(dx, dy);
    launch.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
    launch.style.opacity = String(Math.max(0.25, 1 - d / 140));
  }, { passive: true });
  launch.addEventListener('touchend', function(){
    if(!dragging) return;
    dragging = false;
    launch.style.transition = '';
    launch.style.transform = '';
    launch.style.opacity = '';
    if(dx > 60 || dy > 50){ swallow = true; putAway(); }
  });
  launch.addEventListener('click', function(e){
    if(swallow){ swallow = false; e.stopImmediatePropagation(); e.preventDefault(); }
  }, true);

  /* ---- Open and close ---- */
  function open(){
    panel.hidden = false;
    requestAnimationFrame(function(){ root.classList.add('is-open'); });
    root.querySelector('[data-con-open]').setAttribute('aria-expanded','true');
    if(!chips.childElementCount) showRoot();
    setTimeout(function(){ input.focus({preventScroll:true}); }, 320);
  }
  function close(){
    root.classList.remove('is-open');
    root.querySelector('[data-con-open]').setAttribute('aria-expanded','false');
    setTimeout(function(){ panel.hidden = true; }, 320);
  }
  launch.addEventListener('click', open);
  root.querySelectorAll('[data-con-close]').forEach(function(b){ b.addEventListener('click', close); });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  /* ---- Message helpers ---- */
  function scroll(){ body.scrollTop = body.scrollHeight; }

  function say(html, cls){
    var d = document.createElement('div');
    d.className = 'hy-con__msg hy-con__msg--' + (cls || 'in');
    d.innerHTML = html;
    body.insertBefore(d, chips);
    scroll();
    return d;
  }

  function think(then){
    if(reduce){ then(); return; }
    var t = document.createElement('div');
    t.className = 'hy-con__msg hy-con__msg--in hy-con__typing';
    t.innerHTML = '<i></i><i></i><i></i>';
    body.insertBefore(t, chips);
    scroll();
    setTimeout(function(){ t.remove(); then(); }, 420 + Math.random()*260);
  }

  function setChips(list){
    chips.innerHTML = '';
    list.forEach(function(c){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hy-con__chip';
      b.textContent = c.label;
      b.addEventListener('click', function(){
        say('<p>' + c.label + '</p>', 'out');
        chips.innerHTML = '';
        think(function(){ c.run(); });
      });
      chips.appendChild(b);
    });
    scroll();
  }

  /* ---- Root menu ---- */
  function showRoot(){
    var list = KB.topics.slice(0, 5).map(function(t){
      return { label: t.chip, run: function(){ answer(t); } };
    });
    list.unshift({ label: 'Help me choose', run: askRoom });
    setChips(list);
  }

  function answer(topic){
    say(topic.answer);
    setChips([
      { label: 'Something else', run: function(){ showRoot(); } },
      { label: 'Help me choose', run: askRoom }
    ]);
  }

  /* ---- Advisor ---- */
  var picked = { room: '', need: '' };

  function askRoom(){
    say('<p>Happy to. Which room is it for?</p>');
    setChips(KB.rooms.map(function(r){
      return { label: r.label, run: function(){ picked.room = r.tag; askNeed(); } };
    }));
  }

  function askNeed(){
    say('<p>And what is the room missing?</p>');
    setChips(KB.needs.map(function(n){
      return { label: n.label, run: function(){ picked.need = n.tag; recommend(); } };
    }));
  }

  function score(p){
    var s = 0;
    var hay = (p.tags || '') + ' ' + (p.type || '');
    if(picked.need && hay.indexOf(picked.need) > -1) s += 3;
    if(picked.room && hay.indexOf(picked.room) > -1) s += 2;
    return s;
  }

  function recommend(){
    var ranked = KB.products.slice().map(function(p){ return { p: p, s: score(p) }; })
      .filter(function(x){ return x.s > 0; })
      .sort(function(a,b){ return b.s - a.s || a.p.priceRaw - b.p.priceRaw; })
      .slice(0, 3);

    if(!ranked.length){
      ranked = KB.products.slice(0, 3).map(function(p){ return { p: p, s: 0 }; });
      say('<p>Nothing matches that exactly yet, the collection is still small. These are the pieces closest to it.</p>');
    } else {
      say('<p>These would suit. ' + tierLine() + '</p>');
    }

    var html = '<div class="hy-con__recs">' + ranked.map(function(x){
      var p = x.p;
      return '<a class="hy-con__rec" href="' + p.url + '">' +
        (p.img ? '<img src="' + p.img + '" alt="" loading="lazy">' : '<span></span>') +
        '<span class="hy-con__recn">' + p.title + '</span>' +
        '<span class="hy-con__recp">' + p.price + '</span></a>';
    }).join('') + '</div>';
    say(html);

    setChips([
      { label: 'Try a different room', run: askRoom },
      { label: 'Something else', run: function(){ showRoot(); } }
    ]);
  }

  /* ---- Free text ---- */
  function match(q){
    q = q.toLowerCase();
    var best = null, bestScore = 0;
    KB.topics.forEach(function(t){
      var s = 0;
      (t.keywords || []).forEach(function(k){
        k = String(k).trim().toLowerCase();
        if(k && q.indexOf(k) > -1) s += k.length;
      });
      if(s > bestScore){ bestScore = s; best = t; }
    });
    return bestScore >= 3 ? best : null;
  }

  form.addEventListener('submit', function(e){
    e.preventDefault();
    var q = input.value.trim();
    if(!q) return;
    say('<p>' + q.replace(/[<>]/g, '') + '</p>', 'out');
    input.value = '';
    chips.innerHTML = '';

    think(function(){
      if(/choose|recommend|suggest|which|help me/i.test(q)){ askRoom(); return; }
      var hit = match(q);
      if(hit){ answer(hit); return; }
      say(KB.fallback.replace('{email}',
        '<a href="mailto:' + KB.email + '?subject=Question%20from%20the%20HaloYard%20site">' + KB.email + '</a>'));
      setChips([{ label: 'Show me the common questions', run: function(){ showRoot(); } }]);
    });
  });
})();
